/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";

export const StyledDoneIcon = styled(DoneIcon)({
  padding: '5px 0px 0px 20px', 
  fontSize: '20px'
})
